import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useEditMode } from '@/contexts/EditModeContext';

type Props = {
  namespace: string;
  i18nKey: string;
  values?: Record<string, any>;
  children?: never;
  className?: string;
};

export const TransEditable: React.FC<Props> = ({ namespace, i18nKey, values, className }) => {
  const { t, i18n } = useTranslation(namespace);
  const { isEditMode, canEdit, setEditTarget } = useEditMode();

  const text = useMemo(() => t(i18nKey, values as any), [t, i18nKey, values, i18n.language]);

  const handleEdit = (e: React.MouseEvent) => {
    if (!isEditMode || !canEdit) return;
    e.preventDefault();
    e.stopPropagation();
    
    setEditTarget({
      candidates: [{
        namespace,
        key: i18nKey,
        currentValue: String(text)
      }],
      position: { x: e.clientX, y: e.clientY }
    });
  };

  if (!isEditMode || !canEdit) {
    return <span className={className}>{text}</span>;
  }

  return (
    <span 
      className={`relative inline-flex items-center cursor-pointer hover:bg-info/20 rounded px-0.5 transition-colors ${className || ''}`}
      onClick={handleEdit}
      title={`Edit: ${namespace}:${i18nKey}`}
    >
      <span className="border-b border-dotted border-white/50">
        {text}
      </span>
      <span className="ml-1 text-[8px] opacity-50 select-none">✎</span>
    </span>
  );
};
